import React from 'react';

interface EMRItem {
  name?: string;
  id?: string | number;
}

interface EMRCellProps {
  row: any;
  field: string;
}

const EMRCell: React.FC<EMRCellProps> = ({ row, field }) => {
  const emr: EMRItem[] = row?.[field];

  if (!emr || emr.length === 0) {
    return null;
  }

  return (
    <div className="space-y-1">
      {emr.map((item, index) => (
        <div key={item?.id || index} className="flex items-start">
          <span className="text-sm">{item?.name || 'n/a'}</span>
        </div>
      ))}
    </div>
  );
};

export default EMRCell;
